import {startOfDay} from 'date-fns';

import {type ListCampaignResponseBody} from '@dms/api/sales';

import {parseDate} from 'shared/web';

export const doCampaignPeriodsOverlap = (
  period: {from: Date; to: Date},
  campaign: Pick<ListCampaignResponseBody, 'validFrom' | 'validTo'>
) => {
  const entered = {from: startOfDay(period.from), to: startOfDay(period.to)};
  const stored = {
    from: parseDate(startOfDay(campaign.validFrom)),
    to: parseDate(startOfDay(campaign.validTo)),
  };

  return entered.from <= stored.to && stored.from <= entered.to;
};
